export default [
    "24 24",
    '<path id="Vector" d="M16 10L12 14L8 10" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]

